"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.approvalQueue.title': '审批队列',
    'socialMediaPlan.approvalQueue.desc': '等待审核的帖子',
    'socialMediaPlan.approvalQueue.proposedDate': '建议日期：',
    'socialMediaPlan.approvalQueue.preview': '预览',
    'socialMediaPlan.approvalQueue.reject': '拒绝',
    'socialMediaPlan.approvalQueue.approve': '批准',
    'socialMediaPlan.approvalQueue.rejectConfirm': '拒绝此帖子并移回草稿？',
    'socialMediaPlan.approvalQueue.approved': '帖子已批准待排程',
    'socialMediaPlan.approvalQueue.rejected': '帖子已移回草稿',
};
